import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as NoJobIcon } from '../../../assets/images/no-job-icon.svg';

import styles from './EmptyOpeningList.module.scss';

const EmptyOpeningList = () => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.container}>
      <NoJobIcon />
      <p className={styles.content}>{t('recommendations.noMatchingJobs')}</p>
    </div>
  );
};

export default EmptyOpeningList;
